module.exports = __webpack_public_path__ + "img/Group 5320.aba455d3.png";